// extracted by mini-css-extract-plugin
export default {"branch-grp-report-container":"branchGroup_branch-grp-report-container__WdjPh"};